"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportedTradingPartner = void 0;
exports.SupportedTradingPartner = {
    FULFILLMENT_BY_AMAZON: 'FULFILLMENT_BY_AMAZON'
};
//# sourceMappingURL=supported-trading-partner.js.map